import styles from './Description.module.css'

type DescriptionProps = {
  children: React.ReactNode | string
}

const Description = ({children, ...restProps}: React.HTMLAttributes<HTMLElement> & DescriptionProps) => {
  if (typeof children === 'string') {
    return (
      <p className={styles.Text} {...restProps}>
        {children}
      </p>
    )
  }

  return (
    <span className={styles.Box} {...restProps}>
      {children}
    </span>
  )
}
Description.displayName = 'ControlGroup.Description'

export default Description
